
/* =========================================
   ROSE & LOUIS
   BROADCAST 6.2.0

   UPSELL SWITCHES + RODAPE DINAMICO

   - Adicionar/remover sem F5
   - Sincronizar interruptores
   - Atualizar badge progressivo
   - Somar os valores verdes Economisez
   - Atualizar apos alteracoes no carrinho
========================================= */

(() => {
  const SELECTOR =
    'cart-drawer .custom-recommended-products [data-rl-upsell-switch]';

  const ROOT = window.Shopify?.routes?.root || '/';

  let busy = false;

  /* =====================================
     API SHOPIFY
  ===================================== */

  async function request(path, options = {}) {
    const response = await fetch(ROOT + path, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...options
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Erro ao atualizar o carrinho.'
      );
    }

    return data;
  }

  async function getCart() {
    return request('cart.js');
  }

  /* =====================================
     SINCRONIZAR INTERRUPTORES
  ===================================== */

  function syncSwitches(cart) {
    document.querySelectorAll(SELECTOR).forEach(button => {
      const variantId = Number(button.dataset.variantId);

      const active = cart.items.some(item =>
        Number(item.variant_id) === variantId &&
        item.quantity > 0
      );

      button.setAttribute(
        'aria-checked',
        String(active)
      );
    });
  }

  /* =====================================
     REFRESH NATIVO DO BROADCAST
  ===================================== */

  function refreshBroadcastCart() {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        document.removeEventListener(
          'theme:cart:change',
          onChange
        );

        reject(new Error(
          'O Broadcast não confirmou a atualização visual.'
        ));
      }, 8000);

      function onChange() {
        clearTimeout(timeout);

        document.removeEventListener(
          'theme:cart:change',
          onChange
        );

        resolve();
      }

      document.addEventListener(
        'theme:cart:change',
        onChange
      );

      document.dispatchEvent(
        new CustomEvent('theme:cart:refresh', {
          bubbles: true
        })
      );
    });
  }

  /* =====================================
     FORMATACAO DE MOEDA
  ===================================== */

  function formatMoney(cents, currency) {
    const locale =
      document.documentElement.lang || 'fr-FR';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  /* =====================================
     LER VALORES VERDES ECONOMISEZ

     Exemplo:
     Economisez €430,06
     Economisez €516,09

     Total: €946,15
  ===================================== */

  function parseMoney(text) {
    let value = String(text || '')
      .replace(/[\u00a0\u202f\s]/g, '')
      .replace(/[^\d,.-]/g, '');

    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');

    if (comma >= 0 && dot >= 0) {
      if (comma > dot) {
        value = value.replace(/\./g, '');
        value = value.replace(',', '.');
      } else {
        value = value.replace(/,/g, '');
      }
    } else if (comma >= 0) {
      const decimals = value.length - comma - 1;

      if (decimals === 2) {
        value = value.replace(',', '.');
      } else {
        value = value.replace(/,/g, '');
      }
    } else if (dot >= 0) {
      const decimals = value.length - dot - 1;

      if (decimals !== 2) {
        value = value.replace(/\./g, '');
      }
    }

    const amount = Number(value);

    return Number.isFinite(amount)
      ? Math.round(amount * 100)
      : 0;
  }

  function getDisplayedSavings() {
    const drawer = document.querySelector(
      'cart-drawer'
    );

    if (!drawer) return 0;

    let total = 0;

    const savings = drawer.querySelectorAll(
      '.cart__item .rl-cart-item-savings'
    );

    savings.forEach(element => {
      total += parseMoney(element.textContent);
    });

    return total;
  }

  /* =====================================
     DESCONTO PROGRESSIVO

     1 unidade  = 0%
     2 unidades = 20%
     3 unidades = 25%
     4+ unidades = 30%
  ===================================== */

  function getDiscountTier(quantity) {
    if (quantity >= 4) return 30;
    if (quantity === 3) return 25;
    if (quantity === 2) return 20;

    return 0;
  }

  /* =====================================
     ATUALIZAR BADGE VERMELHO
  ===================================== */

  function updateDiscountBadge(cart) {
    const summary = document.querySelector(
      'cart-drawer .rl-footer-summary'
    );

    if (!summary) return;

    const label = summary.querySelector(
      '.rl-footer-summary__label'
    );

    if (!label) return;

    const tier = getDiscountTier(
      cart.item_count
    );

    let badge = label.querySelector(
      '.rl-footer-summary__badge'
    );

    if (tier === 0) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');

      badge.className =
        'rl-footer-summary__badge';

      label.appendChild(badge);
    }

    badge.innerHTML = `
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        width="15"
        height="15"
        fill="currentColor"
      >
        <path d="M20.59 13.41 13.4 20.6a2 2 0 0 1-2.83 0l-7.17-7.17A2 2 0 0 1 2.8 12V5a2 2 0 0 1 2-2h7a2 2 0 0 1 1.41.59l7.38 7.38a1.73 1.73 0 0 1 0 2.44ZM7.5 7A1.5 1.5 0 1 0 7.5 10a1.5 1.5 0 0 0 0-3Z"/>
      </svg>
      <span>−${tier} %</span>
    `;
  }

  /* =====================================
     ATUALIZAR TOTAL DAS REDUCOES
  ===================================== */

  function updateSavings(cart) {
    const value = document.querySelector(
      'cart-drawer .rl-footer-summary__value'
    );

    if (!value) return;

    const total = getDisplayedSavings();

    value.textContent =
      '− ' + formatMoney(total, cart.currency);
  }

  /* =====================================
     SINCRONIZAR RODAPE
  ===================================== */

  function updateFooter(cart) {
    updateDiscountBadge(cart);
    updateSavings(cart);
  }

  /* =====================================
     ATUALIZACAO AUTOMATICA
  ===================================== */

  let footerTimer = null;
  let refreshSequence = 0;

  function scheduleFooterUpdate() {
    clearTimeout(footerTimer);

    footerTimer = setTimeout(async () => {
      const sequence = ++refreshSequence;

      try {
        const cart = await getCart();

        if (sequence !== refreshSequence) {
          return;
        }

        updateFooter(cart);
        syncSwitches(cart);

      } catch (error) {
        console.error(
          'Rose & Louis Footer:',
          error
        );
      }
    }, 180);
  }

  /* =====================================
     OBSERVAR ALTERACOES NO DRAWER
  ===================================== */

  function observeDrawer() {
    const drawer = document.querySelector(
      'cart-drawer'
    );

    if (!drawer) return;

    const observer = new MutationObserver(
      mutations => {

        const relevant = mutations.some(
          mutation => {
            const target =
              mutation.target.nodeType === 1
                ? mutation.target
                : mutation.target.parentElement;

            if (!target) return false;

            // Ignorar alteracoes feitas no
            // proprio resumo para evitar ciclos.
            if (target.closest(
              '.rl-footer-summary'
            )) {
              return false;
            }

            // Observar produtos e quantidades.
            return Boolean(
              target.closest(
                '.drawer__body, ' +
                '[data-cart-drawer-body], ' +
                'cart-items, ' +
                '.drawer__items, ' +
                '.cart__item'
              )
            );
          }
        );

        if (relevant) {
          scheduleFooterUpdate();
        }
      }
    );

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* =====================================
     INICIALIZAR
  ===================================== */

  async function initialize() {
    try {
      const cart = await getCart();

      syncSwitches(cart);
      updateFooter(cart);

      document.documentElement.classList.add(
        'rl-upsell-ready'
      );

    } catch (error) {
      console.error('Rose & Louis:', error);
    }

    observeDrawer();
  }

  /* =====================================
     ADICIONAR E REMOVER UPSELLS
  ===================================== */

  document.addEventListener(
    'click',
    async event => {

      const button = event.target.closest(
        SELECTOR
      );

      if (!button || busy || button.disabled) {
        return;
      }

      const variantId = Number(
        button.dataset.variantId
      );

      if (!variantId) return;

      busy = true;
      button.disabled = true;

      const drawer = document.querySelector(
        'cart-drawer#cart-drawer'
      );

      const scrollArea = drawer?.querySelector(
        '[data-cart-drawer-body]'
      );

      const previousScroll =
        scrollArea?.scrollTop || 0;

      let mutationCompleted = false;

      try {
        const cart = await getCart();

        const matchingItems = cart.items.filter(
          item =>
            Number(item.variant_id) === variantId
        );

        if (matchingItems.length > 0) {

          /* REMOVER */

          for (const item of matchingItems) {
            await request('cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            });
          }

        } else {

          /* ADICIONAR */

          await request('cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1
              }]
            })
          });
        }

        mutationCompleted = true;

        /* REFRESH BROADCAST */

        await refreshBroadcastCart();

        const updatedCart = await getCart();

        syncSwitches(updatedCart);
        updateFooter(updatedCart);

        scheduleFooterUpdate();

        if (scrollArea?.isConnected) {
          scrollArea.scrollTop = previousScroll;
        }

      } catch (error) {
        console.error(
          'Rose & Louis Upsell:',
          error
        );

        try {
          const cart = await getCart();
          syncSwitches(cart);
          updateFooter(cart);
        } catch (_) {}

        if (mutationCompleted) {
          alert(
            'O produto foi alterado, mas não ' +
            'foi possível confirmar a atualização ' +
            'visual. Verifica o carrinho.'
          );
        } else {
          alert(
            error.message ||
            'Não foi possível alterar o produto.'
          );
        }

      } finally {
        busy = false;

        document.querySelectorAll(
          SELECTOR
        ).forEach(el => {
          el.disabled = false;
        });
      }
    }
  );

  /* =====================================
     EVENTOS NATIVOS BROADCAST
  ===================================== */

  document.addEventListener(
    'theme:cart:change',
    scheduleFooterUpdate
  );

  document.addEventListener(
    'theme:cart:refresh',
    () => {
      // O refresh pode começar antes da
      // renderização. A atualização definitiva
      // acontece após theme:cart:change.
    }
  );

  /* =====================================
     ARRANQUE
  ===================================== */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();
